import { ethers } from "ethers";
import { useEffect, useMemo } from "react";
import Loader from "react-spinners/GridLoader";
import { useTable } from "react-table";
import styled from "styled-components";
import { TableCellsMerge } from "styled-icons/fluentui-system-filled";

import { Cellular3gDimensions } from "@styled-icons/fluentui-system-filled/Cellular3g";

import { Metadata, useProvenance } from "../../hooks/useProvenance";

const StyledTable = styled.table`
	font-size: 11pt;
	max-width: 90vw;
`

const StyledTableBody = styled.tbody`
	text-align: center;
	font-family: 'Roboto Mono';
	font-weight: bold;
	color: ${({ theme }) => theme.white};
`

const StyledTableData = styled.td`
	width: auto;
	max-width: 256ch;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	${({ theme }) => theme.mediaWidth.upToSmall`
		max-width: 10ch;
  `};
`

const ProvenanceRecordTable = (props: any) => {
	const { metadata, loading } = useProvenance()

	const columns = useMemo(
		() => [
			{
				Header: 'Random Squence Index',
				accessor: 'randSeqIndex' as keyof Metadata,
			},
			{
				Header: 'Token ID',
				accessor: `tokenID` as keyof Metadata,
			},
			{
				Header: 'Image Hash',
				accessor: 'imageHash' as keyof Metadata,
			},
			{
				Header: 'Image CID',
				accessor: 'imageCID' as keyof Metadata,
			},
		],
		[]
	)

	const tableInstance = useTable<Metadata>({
		columns,
		data: !!metadata ? metadata : [],
	})

	const { getTableProps, getTableBodyProps, rows, headers, prepareRow } =
		tableInstance

	return metadata != null && metadata.length > 0 ? (
		<StyledTable {...getTableProps()}>
			{/* Apply the table body props */}
			<StyledTableBody {...getTableBodyProps()}>
				{
					// Loop over the table rows
					rows.map((row) => {
						// Prepare the row for display
						prepareRow(row)
						return (
							// Apply the row props
							<tr {...row.getRowProps()} key={row.id}>
								{
									// Loop over the rows cells
									row.cells.map((cell, index) => {
										const { key, ...restCellProps } = cell.getCellProps()
										// Apply the cell props
										return (
											<StyledTableData key={key} {...restCellProps}>
												{
													// Render the cell contents
													cell.render('Cell')
												}
											</StyledTableData>
										)
									})
								}
							</tr>
						)
					})
				}
			</StyledTableBody>
		</StyledTable>
	) : (
		<Loader
			color="#2172E5"
			loading={loading}
			css={`
				// padding: 2rem 0;
			`}
		/>
	)
}

export default ProvenanceRecordTable
